import {  message } from 'antd';

// pass in 0 to enforce closability
export const showSuccessMessage = (text, duration=3) => {
  message.success(text, duration);
}

// pass in 0 to enforce closability
export const showErrorMessage = (text, duration=3) => {
  message.error(text, duration);
}

export const clearAllMessages = () => {
  message.destroy();
}

export const COLORS = {
  BACKGROUND_GREY: "#f0f0f0",
  PRIMARY_COLOR: "#0098fb",
  LIVE_GREEN: "#32cd32",
  HIDDEN: "#a9a9a9"
}

export const validateEmail = (email) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
